export enum ViesCountry {
  ES = 'ES'
}

export class ViesValidationResult {
  constructor(
    readonly valid: boolean,
    readonly countryCode: string,
    readonly vatNumber: string,
    readonly name: string,
    readonly address: string,
    readonly error: string
  ) {}

  static from(output: { [key: string]: string | boolean }): ViesValidationResult {
    return new ViesValidationResult(
      (output.valid as boolean) || false,
      (output.countryCode as string) || '',
      (output.vatNumber as string) || '',
      (output.name as string) || '',
      (output.address as string) || '',
      (output.error as string) || ''
    )
  }
}

export const buildCif = (cif: string, country: string): string => {
  const cifUpperCase = cif.toUpperCase()
  const startsWithLetters = /^[A-Z]{2}/.test(cifUpperCase)

  if (startsWithLetters) {
    return cifUpperCase
  }

  const resolvedCountry = country || ViesCountry.ES
  return resolvedCountry + cif
}

export const sanitizeViesField = (value: string): string => {
  if (!value) {
    return ''
  }
  const hasAlphanumeric = /[a-zA-Z0-9]/.test(value)
  if (!hasAlphanumeric) {
    return ''
  }
  return value.trim()
}
